import React, { useRef } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function ModalBulkCreateUserResult(props) {
    const { open, onClose, result } = props;

    const exportToExcel = () => {
        if (!result || !result.details) return;

        const worksheetData = result.details.map(detail => ({
            "Họ tên": detail.herdsmanName,
            "Trạng thái": detail.success ? "Thành công" : "Thất bại",
            "Tên đăng nhập": detail.userName || "",
            "Mật khẩu": detail.password || "",
            "Lỗi": detail.errorMessage || ""
        }));

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Results");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, `BulkCreateUserResults_${new Date().getTime()}.xlsx`);
    };

    if (!open) return null;

    return (
        <div
            className={`modal fade ${open ? 'show' : ''}`}
            style={{ display: open ? 'block' : 'none', zIndex: 1051 }}
            data-backdrop="static"
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Kết quả tạo tài khoản</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        <div className="alert alert-info">
                            Tổng cộng: {result?.totalProcessed} | Thành công: {result?.successCount} | Thất bại: {result?.failedCount}
                        </div>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Họ tên</th>
                                        <th>Trạng thái</th>
                                        <th>Tên đăng nhập</th>
                                        <th>Mật khẩu</th>
                                        <th>Lỗi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result?.details?.map((detail, index) => (
                                        <tr key={index}>
                                            <td>{detail.herdsmanName}</td>
                                            <td>
                                                {detail.success ?
                                                    <span className="badge badge-success">Thành công</span> :
                                                    <span className="badge badge-danger">Thất bại</span>
                                                }
                                            </td>
                                            <td>{detail.userName}</td>
                                            <td>{detail.password}</td>
                                            <td className="text-danger">{detail.errorMessage}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" onClick={exportToExcel}>
                            Xuất Excel
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            Đóng
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
